import api from "@/services/api";
import { FeedbackResponse, FeedbackSubmission } from "@/types/feedback";

export const feedbackService = {
  async submit(submission: FeedbackSubmission): Promise<FeedbackResponse> {
    const form = new FormData();
    form.append("category", submission.category);
    form.append("title", submission.title);
    form.append("description", submission.description);
    if (submission.pageUrl) form.append("pageUrl", submission.pageUrl);
    for (const file of submission.screenshots) {
      form.append("screenshots", file, file.name);
    }
    const res = await api.post("/linear/feedback", form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  },
};
